import { createContext, useContext, useSyncExternalStore } from 'react';
import { onlineManager } from '@tanstack/react-query';
import type { DeskEngine, DeskSnapshot } from './engine';

// Context + hooks live apart from DeskProvider.tsx (react-refresh/
// only-export-components — see authContext.ts).
export const DeskContext = createContext<DeskEngine | null>(null);

export function useDeskEngine(): DeskEngine {
  const engine = useContext(DeskContext);
  if (!engine) throw new Error('useDeskEngine must be used within a DeskProvider');
  return engine;
}

export function useDeskSnapshot(): DeskSnapshot {
  const engine = useDeskEngine();
  return useSyncExternalStore(engine.subscribe, engine.getSnapshot);
}

/** TanStack Query's own online signal — the same one that pauses and
 * resumes the queue, so the UI never disagrees with the sync engine. */
export function useIsOnline(): boolean {
  return useSyncExternalStore(
    (listener) => onlineManager.subscribe(listener),
    () => onlineManager.isOnline(),
  );
}
